import { render, staticRenderFns } from "./AdmanHistory.vue?vue&type=template&id=384c49ac&scoped=true&"
import script from "./AdmanHistory.vue?vue&type=script&lang=js&"
export * from "./AdmanHistory.vue?vue&type=script&lang=js&"
import style0 from "./AdmanHistory.vue?vue&type=style&index=0&id=384c49ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384c49ac",
  null
  
)

export default component.exports